import type React from 'react';

import { BodyLarge } from 'components/typography/Typography';

interface CompetitorsTableSubtitleProps {
  subtitle?: string;
}

const CompetitorsTableSubtitle: React.FC<React.PropsWithChildren<CompetitorsTableSubtitleProps>> = ({ subtitle }) => {
  return <BodyLarge>{subtitle}</BodyLarge>;
};

export default CompetitorsTableSubtitle;
